import { styled } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { QButton, QTypography } from '@kw/quokka-ui';
import { logoutLocal } from '../../auth';
import { zendeskSSOUrls } from './zendeskUrls';

/**
 * Shown when an authenticated user has none of the menu permissions and
 * therefore has no page they are allowed to land on. See getDefaultRoute and
 * the ProtectedRoute fallback / Index redirect that route here.
 */
export default function NoAccess() {
  const auth0 = useAuth0();
  const { isAuthenticated, user } = auth0;

  return (
    <StyledDiv>
      <StyledQTypography>
        Your account doesn&apos;t have permission to view any pages in Q-Scout. Please contact your organization administrator or Quokka
        customer support to request access.
      </StyledQTypography>
      {isAuthenticated && user?.email && (
        <StyledUserMessage>
          You&apos;re signed in as <b>{user.email}</b>
        </StyledUserMessage>
      )}
      <StyledButtonRow>
        <StyledQButton variant="filled" onClick={() => window.open(zendeskSSOUrls.customerSupport, '_blank', 'noopener,noreferrer')}>
          Contact customer support
        </StyledQButton>
        <StyledQButton variant="outlined" onClick={() => logoutLocal(auth0)}>
          Log out
        </StyledQButton>
      </StyledButtonRow>
    </StyledDiv>
  );
}

const StyledDiv = styled('div')`
  max-width: 740px;
  margin: 100px auto auto auto;
  padding: 0 20px;
`;

const StyledQTypography = styled(QTypography)`
  font-size: 30px;
  font-weight: 400;
  line-height: 45px;
`;

const StyledUserMessage = styled('p')`
  font-size: 18px;
  line-height: 25px;
  margin: 50px 0 10px 0;
`;

const StyledButtonRow = styled('div')`
  display: flex;
  gap: 16px;
  margin-top: 30px;
`;

const StyledQButton = styled(QButton)`
  padding: 0 50px;
`;
